import { render, staticRenderFns } from "./CStandBy.vue?vue&type=template&id=299b668c&scoped=true&"
import script from "./CStandBy.vue?vue&type=script&lang=js&"
export * from "./CStandBy.vue?vue&type=script&lang=js&"
import style0 from "./CStandBy.vue?vue&type=style&index=0&id=299b668c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299b668c",
  null
  
)

export default component.exports